import HttpError from "./HttpError";
import errorResolver from "../errorResolver";
import { HttpResponse } from "../../Common/request";

/**
 * If "details" from domain exception should be show as is right from exception, set validationErrorsAsText to true. It will set alreadyTranslated to true on HttpError.
 */
export function resolveNoContent(errorMessage = "Could not process resource.", validationErrorsAsText = false) {
    return res => {
        if (res.headers["content-type"]?.includes("application/json") && typeof res.body === "string") {
            res.body = JSON.parse(res.body);
        }

        if (validationErrorsAsText) {
            errorResolver.throwValidationErrorsAsText(res);
        }
        errorResolver.throwValidationErrors(res);
        errorResolver.throwSimpleError(res);

        if (res.statusCode !== 204) {
            throw new HttpError(errorMessage, res.statusCode, res.body);
        }
    };
}

export function resolveWithBody<T>(errorMessage = "Could not process resource.") {
    return (res: HttpResponse<T>) => {
        if (res.headers["content-type"]?.includes("application/json") && typeof res.body === "string") {
            res.body = JSON.parse(res.body);
        }

        errorResolver.throwValidationErrors(res);
        errorResolver.throwSimpleError(res);

        if (res.statusCode !== 200 && res.statusCode !== 201) {
            throw new HttpError(errorMessage, res.statusCode, res.body);
        }

        return res.body;
    };
}

export function resolveWithAccepted<T>(errorMessage = "Could not process resource.", validationErrorsAsText = false) {
    return (res: HttpResponse<T>) => {
        if (res.headers["content-type"]?.includes("application/json") && typeof res.body === "string") {
            res.body = JSON.parse(res.body);
        }

        if (validationErrorsAsText) {
            errorResolver.throwValidationErrorsAsText(res);
        }
        errorResolver.throwValidationErrors(res);
        errorResolver.throwSimpleError(res);

        if (res.statusCode !== 202) {
            throw new HttpError(errorMessage, res.statusCode, res.body);
        }

        return res.body;
    };
}
